export default __webpack_public_path__ + "media/images/icons/trash-solid-8b6b72844fd26d9c9e5ef9e130cd411e.svg";